module.exports = process.env.APPLICATION_NAME;
